import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/storage';
import 'firebase/functions';

// Initialize Firebase
var config = {
  apiKey: 'AIzaSyAKR1QCNUwPUj0QwRMGobUroNhYdoQqKgI',
  authDomain: 'thrive-df813.firebaseapp.com',
  databaseURL: 'https://thrive-df813.firebaseio.com',
  projectId: 'thrive-df813',
  storageBucket: 'thrive-df813.appspot.com',
  messagingSenderId: '183462802383'
};
firebase.initializeApp(config);

// Firebase utils
const fb = firebase;
const db = firebase.firestore();
const auth = firebase.auth();
const storage = firebase.storage();
const fbfunctions = firebase.functions();

// firebase collections
const usersCollection = db.collection('users');
const adminsCollection = db.collection('admins');
const locationsCollection = db.collection('locations');
const messagesCollection = db.collection('messages');

// require locationId
const allBookingsCollection = (locationId, start, end) =>
  db
    .collectionGroup('bookings')
    .where('location_id', '==', locationId)
    .where('start_timestamp', '>=', Number(start))
    .where('start_timestamp', '<=', Number(end));
const roomsCollection = locationId =>
  locationsCollection.doc(locationId).collection('meeting-rooms');
const bookingsCollection = (locationId, roomId) =>
  roomsCollection(locationId)
    .doc(roomId)
    .collection('bookings');
const commentsCollection = messageId =>
  messagesCollection.doc(messageId).collection('comments');

const FieldValue = firebase.firestore.FieldValue;
const FieldPath = firebase.firestore.FieldPath;

export {
  fb,
  db,
  auth,
  storage,
  fbfunctions,
  allBookingsCollection,
  usersCollection,
  adminsCollection,
  locationsCollection,
  roomsCollection,
  bookingsCollection,
  messagesCollection,
  commentsCollection,
  FieldValue,
  FieldPath
};
